import { TemplateItem } from "types/";
import { Shape, SHAPE_TYPES } from "../../../types";
import {
  generateRectangle,
  generateCircle,
} from "../../mapTemplateStateToServerTemplate";
import { generateLine } from "./Line";

export const generateShapeGraphics = (
  shape: Shape
): TemplateItem["graphics"] => {
  switch (shape.shapeType) {
    case SHAPE_TYPES.RECTANGLE:
      return generateRectangle(shape.background, shape.stroke);
    case SHAPE_TYPES.CIRCLE:
      return generateCircle(shape.background, shape.stroke);
    case SHAPE_TYPES.LINE:
      return generateLine(shape);
  }
};
